<template>
  <div class="box">
    <div class="container">
      <div class="content">
        <img class="player-img" id="player-on" src="../../../assets/iphone.png"/>
        <div class="depart-box">
          <h1><i>TO {{$t('运动队&运动员')}}</i></h1>
          <p>{{$t('随时掌握比赛进程；比赛信息互联互通')}}</p>
          <p>{{$t('检录提醒，及时提醒运动员在恰当时间去完成检录')}}</p>
          <p>{{$t('比赛过程中自动完成攻防双方技术统计')}}</p>
          <p>{{$t('提供对战双方攻防数据统计分析，便于进行赛后总结，')}}</p>
          <p>{{$t('针对性调整训练方法，有效提高运动员成绩')}}</p>
          <p>{{$t('所有比赛战绩、胜率、积分状况，技术指标等海量数据，实时完整的永久保存')}}</p>
          <div class="look-btn" @click="serviceDetail">{{$t('查看详细介绍')}}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Department',
  components: {},
  mounted () {

  },
  data () {
    return {

    }
  },
  computed: {},
  methods: {
    serviceDetail () {
      this.$message.warn('暂未更新')
      return
    //   this.$router.push({
    //     name:'Service',
    //     params:{
    //       index:2
    //     }
    //   })
    }
  }
}
</script>
<style lang="scss" scoped>
.box{
  width: 100%;
  position: relative;
  top:-70px;
}
.container{
  width: 100%;
  height: 600px;
  background-image: url('../../../assets/teamPlayerBg.jpg');
  background-repeat: no-repeat;
  background-size: cover;
}
.content{
  width: 1200px;
  margin: 0 auto;
  position: relative;
}
.depart-box{
  width: 640px;
  height: 500px;
  float: left;
}
.depart-box h1{
    font-weight: bold;
    font-size: 40px;
    padding-top: 60px;
    margin-bottom: 50px;
}
.depart-box p{
  font-weight: bold;
    font-size: 14px;
}
.player-img{
  position: absolute;
  right: 600px;
  top: 50px;
  transition: 0.3s;
  height: 550px;
}
.player-on-box{
  position: absolute;
  right: -120px;
  top: 50px;
  transition: 0.3s;
}
.look-btn{
    width: 200px;
    height: 60px;
    border: 1px solid #000;
    cursor: pointer;
    border-radius: 60px;
    margin-top: 60px;
    line-height: 60px;
    text-align: center;
    font-size: 18px;
    font-weight: bold;
    opacity: 0.6;
}
.look-btn:hover{
    opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/daoba-match/views/home/components/TeamPlayer.vue